import { useSuspenseQuery } from '@tanstack/react-query';
import { getVisitOptions } from '@generated';
import { Calendar, MapPin, User } from 'lucide-react';
import { Button } from '~/shared/components/buttons/Button';
import { Modal } from '~/shared/components/modal/Modal';
import { formatAddress } from '~/util/functions';
import { FooterButtonContainer } from '~/shared/forms/buttons/FooterButtonContainer';
import { formatTimespanForDisplay } from '~/util/date';
import { useNavigate } from 'react-router-dom';
import { getVisitRoutePath } from '~/pages/visits/utils';

export function VisitModal({ stayId, visitId, onClose }: { stayId: string; visitId: string; onClose: () => void }) {
	const navigate = useNavigate();
	const handleViewVisit = () => {
		navigate(getVisitRoutePath(stayId, visitId));
	};
	return (
		<Modal
			title="Referral Details"
			closeModal={onClose}
			footer={
				<FooterButtonContainer>
					<Button onClick={handleViewVisit} appearance="outline" intent="neutral" label="View Visit" />
					<Button onClick={onClose} appearance="outline" intent="neutral" label="Close" />
				</FooterButtonContainer>
			}
		>
			<VisitModalContent visitId={visitId} onClose={onClose} />
		</Modal>
	);
}

function VisitModalContent({ visitId, onClose }: { visitId: string; onClose: () => void }) {
	const { data: visit } = useSuspenseQuery(getVisitOptions(visitId));

	return (
		<div className="space-y-4">
			<div className="flex items-center gap-2">
				<User size={16} className="text-gray-400" />
				<h3 className="text-base font-semibold text-gray-900">{visit.patient.fullName}</h3>
				<span className="text-sm text-gray-500">#{visit.patient.patientIdentifier}</span>
			</div>
			<div className="flex items-center gap-1 text-sm text-gray-600">
				<MapPin size={16} className="text-gray-400" />
				<span>{formatAddress(visit.visitAddress)}</span>
			</div>
			<div className="flex items-center gap-4">
				<div className="flex items-center gap-1 text-sm text-gray-600">
					<Calendar size={16} className="text-gray-400" />
					<span className="font-medium">Visit Date/Time:</span>
					<span>{visit.timeOutUtc ? formatTimespanForDisplay(visit.timeInUtc, visit.timeOutUtc) : '-'}</span>
				</div>
			</div>
		</div>
	);
}
